<mat-toolbar>
	<div class="logo-wrapper">
		<a href="https://dataforseo.com"><img class="logo" src="./assets/ukr-logo.png" alt=""></a><span>Status</span></div>
</mat-toolbar>
